import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from '@common/validation/schemaContainer';
import type { ValidationErrors } from './validation';
import { formatDateIntoString } from './formatDateIntoString';
import { updateValidationErrorsForMany } from './validation';

export type DatePeriod = {
    endDate?: Date | null;
    startDate?: Date | null;
};

export const validateDatePeriodSchema = {
    schema: Koi.object({
        endDate: Koi.koi().date().endDate().allow(null),
        startDate: Koi.koi().date().allow(null),
    }),
};

export function handleValidatePeriod<T>(validatePeriod: {
    datePeriod: DatePeriod;
    errors: ValidationErrors;
    schema: ISchemaContainer<T>;
    setErrors: (errors: ValidationErrors) => void;
}): void {
    const object = {
        endDate: validatePeriod.datePeriod.endDate ? formatDateIntoString(validatePeriod.datePeriod.endDate) : null,
        startDate: validatePeriod.datePeriod.startDate
            ? formatDateIntoString(validatePeriod.datePeriod.startDate)
            : null,
    };

    const newErrors = updateValidationErrorsForMany(validatePeriod.schema, object, validatePeriod.errors, [
        'endDate',
        'startDate',
    ]);
    validatePeriod.setErrors(newErrors);
}
